

export const skillsData = [
  {
    skill: "HTML",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/HTML5_logo_and_wordmark.svg/2048px-HTML5_logo_and_wordmark.svg.png",
  },
  {
    skill: "CSS",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
  },
  {
    skill: "javaScript",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-Hz0FveyfweKelar02d9qnMb752giApH5P96uJ_hCGx7-LjhC3zhkiTyZTkRgL5Q-hnE&usqp=CAU",
  },
  {
    skill: "React",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
  },
  {
    skill: "Redux",
    image: "https://www.svgrepo.com/show/303557/redux-logo.svg",
  },
  {
    skill: "TypeScript",
    image: "https://i.postimg.cc/FsRCXr1c/TS.jpg",
  },
  {
    skill: "Next.js",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpsEwMyLPLvASTvp60Oz1GhwYTnkGlG4OBoQ&usqp=CAU",
  },
  {
    skill: "React-Native",
    image: "https://i.postimg.cc/c4RRzPBY/native.jpg",
  },

  {
    skill: "Tailwind CSS",
    image: "https://i.postimg.cc/Kv6PpxTm/tailwind.jpg",
  },
  {
    skill: "Bootstrap",
    image: "https://i.postimg.cc/pTr5X6j0/boot.jpg",
  },
  {
    skill: "Chakra UI",
    image: "https://media.graphassets.com/91q3gAEGSh6HCrpnPgxS",
  },
  {
    skill: "StoryBook",
    image: "https://i.postimg.cc/9X1gkRXC/storybook.jpg",
  },
  {
    skill: "NodeJs",
    image: "https://i.postimg.cc/kGjjRZYB/node.jpg",
  },
  {
    skill: "Express Js",
    image: "https://upload.wikimedia.org/wikipedia/commons/6/64/Expressjs.png",
  },
  {
    skill: "MongoDB",
    image: "https://i.postimg.cc/NMkCBL18/mongo.jpg",
  },
  {
    skill: "MySQL",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQGGT_pnMHJdps9fGjcDaFSqcfFxO2E7BQk4g&s",
  },
  {
    skill: "Git",
    image: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
  },
  {
    skill: "Github",
    image: "https://cdn-icons-png.flaticon.com/512/25/25231.png",
  },
  {
    skill: "AWS",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2xQcwKitRgXfqdi34DYlocPSEXD2G2zZipg&s",
  },

];
